const constants = require('./constants');
const dateUtil = require('../dateUtil/dateUtil');

export function isOpen(businessHours, currentLocalDateTime, dispatchType)
{
    businessHours = businessHours.filter((businessHourOverride) => businessHourOverride.dispatchTypes.length == 0
        || businessHourOverride.dispatchTypes.includes(dispatchType));

    for (const businessHour of businessHours)
    {
        if (businessHour.type === constants.openingHoursType.allDayClose && isDayConstraintMet(businessHour, currentLocalDateTime))
        {
            return false;
        }

        if (businessHour.type === constants.openingHoursType.allDayOpen && isDayConstraintMet(businessHour, currentLocalDateTime))
        {
            return true;
        }

        if (businessHour.type === constants.openingHoursType.timeSlot)
        {
            let fromDateTime = dateUtil.setTimeComponent(currentLocalDateTime, businessHour.fromHour, businessHour.fromMinute, 0);
            let toDateTime = dateUtil.setTimeComponent(currentLocalDateTime, businessHour.toHour, businessHour.toMinute, 0);

            if (dateUtil.isSameOrBefore(fromDateTime, toDateTime))
            {
                if (isWithinTimeSlotAndDay(businessHour, currentLocalDateTime, fromDateTime, toDateTime))
                {
                    return true;
                }
            }
            else
            {
                toDateTime = dateUtil.addDays(toDateTime, 1);
                if (isWithinTimeSlotAndDay(businessHour, currentLocalDateTime, fromDateTime, toDateTime))
                {
                    return true;
                }
                else
                {
                    fromDateTime = dateUtil.subtractDays(fromDateTime, 1);
                    toDateTime = dateUtil.subtractDays(toDateTime, 1);
                    if (isWithinTimeSlotAndDay(businessHour, currentLocalDateTime, fromDateTime, toDateTime))
                    {
                        return true;
                    }
                }
            }
        }
    }

    return false;
}

function isDayConstraintMet(businessHour, dateTime)
{
    return businessHour.daysOfTheWeek.length === 0 || businessHour.daysOfTheWeek.includes(dateUtil.formatDate(dateTime, 'dddd'))
}

function isWithinTimeSlotAndDay(businessHour, currentLocalDateTime, fromDateTime, toDateTime)
{
    return dateUtil.isSameOrAfter(currentLocalDateTime, fromDateTime)
        && dateUtil.isSameOrBefore(currentLocalDateTime, toDateTime)
        && isDayConstraintMet(businessHour, fromDateTime);
}
